import * as React from 'react';

import { Button, Flex, Typography } from 'antd';

import { AntdRouterLink, PlusOutlinedIcon } from 'components';
import { PATHNAME } from 'utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    CATEGORIES: { CREATE_URL: CATEGORIES_CREATE_URL },
  },
} = PATHNAME;

const CategoriesHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <Flex
    gap='small'
    className='mb-5 max-lg:flex-col lg:items-center lg:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-lg'>
      دسته‌بندی‌ها
    </Typography.Title>
    <Flex gap='small' className='max-lg:flex-wrap'>
      <React.Fragment>{children}</React.Fragment>
      <AntdRouterLink
        to={`${CATEGORIES_CREATE_URL}${DEFAULT_SLUG_SEPARATOR}`}
        className='max-lg:basis-full'
      >
        <Button type='primary' className='w-full' icon={<PlusOutlinedIcon />}>
          افزودن دسته‌بندی‌
        </Button>
      </AntdRouterLink>
    </Flex>
  </Flex>
);

export { CategoriesHeader };
